angular.module('workflow')
    .component('workflowDashboard', {
        bindings: {},
        templateUrl: 'app/workflow/dashboard.html',
        controller: function ($scope, WorkflowService, Principal, $http) {
            this.WorkflowService = WorkflowService

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_WORKFLOW_ALL"]).then(isManager => {
                    this.isManager = isManager
                    return Principal.hasAnyAuthorityPromise(["ROLE_WORKFLOW_MODULE"])
                }).then(isUser => {
                    this.isUser = isUser
                    if (this.isManager || this.isUser) {
                        this.loadStatistics()
                    } else {
                        this.data = null
                    }
                })
            }

            this.loadStatistics = () => {
                return $http.get('/crm/api/workflow/user-statistics').then(response => {
                    this.data = response.data;
                }).catch(() => {
                    this.data = null
                });
            }
        }
    })
